'use client';

import { DetailsCard } from '@/components/molecules/DetailsCard';
import { SeasonInfoDetailsSkeleton } from '@/components/molecules/skeletons/SeasonInfoDetailsSkeleton';
import { useSeasonInfoQuery } from '@/hooks/teamLeagueSeasonInfo/useSeasoninfoQuery';

interface SeasonDetailsProps {
	teamLeagueId: string;
}

export const SeasonDetails = ({ teamLeagueId }: SeasonDetailsProps) => {
	const { data: seasonInfo, isFetching } = useSeasonInfoQuery(teamLeagueId);

	return (
		<>
			{isFetching && <SeasonInfoDetailsSkeleton />}

			{!isFetching && (
				<>
					{seasonInfo?.data?.teamLeagueDescription && (
						<div>
							<DetailsCard
								title="Description"
								content={
									<div
										className="mt-2 font-medium text-gray-700"
										dangerouslySetInnerHTML={{
											__html: seasonInfo?.data?.teamLeagueDescription || '<p></p>'
										}}
									></div>
								}
							/>
						</div>
					)}
				</>
			)}
		</>
	);
};
